/**
 * Graphic component
 * -----------------
 */

/* Imports */

import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import {
  Graphic,
  GraphicOneSc,
  GraphicOneL1,
  GraphicOneL2,
  GraphicOneL3,
  GraphicOneS1,
  GraphicOneS2,
  GraphicOneS3,
  GraphicOneS4,
  GraphicTwoB1,
  GraphicTwoB2,
  GraphicTwoL1,
  GraphicTwoL2,
  GraphicTwoL3,
  GraphicTwoL4,
  GraphicTwoBs1,
  GraphicTwoBs2,
} from "./styles.module.scss";

/* Component */

const GraphicComponent = ({
  item = "",
  toggle = false,
  classes = "",
  threshold = 0.3,
  type = 1,
}) => {
  const graphicsOnePath = `../../../../../latercon/2021/img/graphics/one/`;
  const graphicsTwoPath = `../../../../../latercon/2021/img/graphics/two/`;
  const graphicsOneStaticPath = `../../../../../static/latercon/2021/img/graphics/one/`;
  const graphicsTwoStaticPath = `../../../../../static/latercon/2021/img/graphics/two/`;

  if (classes) classes = ` ${classes}`;

  return (
    <div
      className={`${Graphic} lc-gpx1 lc-p-r lc-vis${classes}`}
      data-v-all
      data-v-toggle={toggle.toString()}
      data-v-item={item}
      data-th={threshold}
      data-type={type}
    >
      <div
        className="lc-p-r"
        style={{ paddingTop: type === 1 ? "71.146511368%" : "60.774107692%" }}
      >
        {type === 1 ? (
          <>
            <div className={`${GraphicOneSc} lc-gpx1__sc lc-scale`} data-sc="m">
              <div className="lc-p-r" style={{ paddingTop: "64.480834134%" }}>
                <StaticImage
                  src={`${graphicsOneStaticPath}screen.png`}
                  alt=""
                  quality={75}
                  placeholder="none"
                />
              </div>
            </div>
            <div
              className={`${GraphicOneSc} lc-gpx1__sc lc-scale`}
              data-sc="m"
              src={`${graphicsOnePath}screen.png`}
              alt=""
            />
            <div className={`${GraphicOneL1} lc-gpx1__l1 lc-o-h`}>
              <img
                className="lc-move-fade-y"
                data-y="100"
                data-spd="s"
                style={{ "--delay": "400ms" }}
                src={`${graphicsOnePath}strategies.png`}
                alt=""
              />
            </div>
            <div className={`${GraphicOneL2} lc-gpx1__l2 lc-o-h`}>
              <img
                className="lc-move-fade-y"
                data-y="100"
                data-spd="s"
                style={{ "--delay": "550ms" }}
                src={`${graphicsOnePath}for-every-single.png`}
                alt=""
              />
            </div>
            <div className={`${GraphicOneL3} lc-gpx1__l3 lc-o-h`}>
              <img
                className="lc-move-fade-y"
                data-y="100"
                data-spd="s"
                style={{ "--delay": "700ms" }}
                src={`${graphicsOnePath}platform.png`}
                alt=""
              />
            </div>
            <img
              className={`${GraphicOneS1} lc-gpx1__s1 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "1350ms" }}
              src={`${graphicsOnePath}instagram.png`}
              alt=""
            />
            <img
              className={`${GraphicOneS2} lc-gpx1__s2 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "1200ms" }}
              src={`${graphicsOnePath}facebook.png`}
              alt=""
            />
            <img
              className={`${GraphicOneS3} lc-gpx1__s3 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "1050ms" }}
              src={`${graphicsOnePath}pinterest.png`}
              alt=""
            />
            <img
              className={`${GraphicOneS4} lc-gpx1__s4 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "900ms" }}
              src={`${graphicsOnePath}tiktok.png`}
              alt=""
            />
          </>
        ) : (
          <>
            <div
              className={`${GraphicTwoB1} lc-gpx2__b1 lc-move-fade-x`}
              data-x="-25"
              data-spd="s"
            >
              <div className="lc-p-r" style={{ paddingTop: "53.604674538%" }}>
                <StaticImage
                  src={`${graphicsTwoStaticPath}bubble-1.png`}
                  alt=""
                  quality={75}
                  placeholder="none"
                />
              </div>
            </div>
            <div className={`${GraphicTwoL1} lc-gpx2__l1 lc-o-h`}>
              <img
                className="lc-move-fade-x"
                data-spd="s"
                style={{ "--delay": "400ms" }}
                src={`${graphicsTwoPath}advice-you.png`}
                alt=""
              />
            </div>
            <div className={`${GraphicTwoL2} lc-gpx2__l2 lc-o-h`}>
              <img
                className="lc-move-fade-x"
                data-spd="s"
                style={{ "--delay": "600ms" }}
                src={`${graphicsTwoPath}can-use.png`}
                alt=""
              />
            </div>
            <img
              className={`${GraphicTwoBs1} lc-gpx2__bs1 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "800ms" }}
              src={`${graphicsTwoPath}thumbs-up.png`}
              alt=""
            />
            <div
              className={`${GraphicTwoB2} lc-gpx2__b2 lc-move-fade-x`}
              data-x="25"
              data-spd="s"
              data-reverse
              style={{ "--delay": "200ms" }}
            >
              <div className="lc-p-r" style={{ paddingTop: "60.7347996%" }}>
                <StaticImage
                  src={`${graphicsTwoStaticPath}bubble-2.png`}
                  alt=""
                  quality={75}
                  placeholder="none"
                />
              </div>
            </div>
            <div className={`${GraphicTwoL3} lc-gpx2__l3 lc-o-h`}>
              <img
                className="lc-move-fade-x"
                data-spd="s"
                style={{ "--delay": "600ms" }}
                src={`${graphicsTwoPath}without.png`}
                alt=""
              />
            </div>
            <div className={`${GraphicTwoL4} lc-gpx2__l4 lc-o-h`}>
              <img
                className="lc-move-fade-x"
                data-spd="s"
                style={{ "--delay": "800ms" }}
                src={`${graphicsTwoPath}the-fluff.png`}
                alt=""
              />
            </div>
            <img
              className={`${GraphicTwoBs2} lc-gpx2__bs2 lc-scale`}
              data-sc="l"
              data-spd="s"
              style={{ "--delay": "400ms" }}
              src={`${graphicsTwoPath}zzz.png`}
              alt=""
            />
          </>
        )}
      </div>
    </div>
  );
};

/* Export */

export default GraphicComponent;
